import { render, staticRenderFns } from "./right-side.vue?vue&type=template&id=2371719e&scoped=true"
import script from "./right-side.vue?vue&type=script&lang=js"
export * from "./right-side.vue?vue&type=script&lang=js"
import style0 from "./right-side.vue?vue&type=style&index=0&id=2371719e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371719e",
  null
  
)

export default component.exports